// frontend/src/utils/http.js
import axios from "axios";

// В дев-режиме ЖЁСТКО используем прокси на /api (CRA setupProxy)
// В проде можно задать полный URL через REACT_APP_API_URL (с /api на конце)
const isDev = process.env.NODE_ENV !== "production";

const API_BASE = isDev
    ? "/api"
    : (process.env.REACT_APP_API_URL || "/api"); // на всякий случай

const http = axios.create({ baseURL: API_BASE });

// отладка — посмотреть, куда реально шлём
if (typeof window !== "undefined") {
  console.log("[http] baseURL =", API_BASE);
}

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwt");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use((response) => {
  const method = response.config?.method?.toLowerCase();
  const path = response.config?.url || '';
  if (typeof window !== 'undefined' && ['post', 'put', 'patch', 'delete'].includes(method) &&
      /^\/(postings|return-scans|preparation-requests)(\/|$)/.test(path)) {
    window.dispatchEvent(new Event('marketcrm:sidebar-counts-changed'));
  }
  return response;
});

export default http;
